'use client';

import NextError from 'next/error';
import { useEffect } from 'react';
import { capturePostHogClientException } from '@/lib/analytics/posthog-client-errors';

export default function RootErrorBoundary({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    capturePostHogClientException(error, {
      digest: error.digest,
      errorSource: 'app_error_boundary',
    });
  }, [error]);

  return (
    <div>
      <NextError statusCode={0} />
      <button onClick={reset} type="button">
        Try again
      </button>
    </div>
  );
}
